// extracted by mini-css-extract-plugin
export default {"main-container-flex":"TncModal_main-container-flex__5O67_","hBit_red_span":"TncModal_hBit_red_span__2cIh0","term-in-use":"TncModal_term-in-use__oyzAh"};